module.exports = __webpack_public_path__ + "img/content.063d0bc1.png";